import React from 'react'
import { Modal } from '../../../atoms/Modal'
import { css } from '@emotion/react'
import { A } from '../../../atoms/A'
import { Button, colors, font, mq } from 'plume-ui'
import Link from 'next/link'
import { loginPath, trialRequestUrl } from '@/lib/url'

type Props = {
  isOpen: boolean
  hideModal: () => void
}

export const TrialModal: React.FC<Props> = (props) => {
  return (
    <Modal
      isHidden={!props.isOpen}
      onClose={props.hideModal}
      css={css`
        max-width: 640px;
        .modal-content {
          padding: 0;
        }
      `}
    >
      <img
        alt="trial modal image"
        src="/static/images/companies/guest/trial.png"
        css={css`
          border-radius: 5px 5px 0 0;
          width: 100%;
        `}
      />
      <div
        css={css`
          display: flex;
          align-items: center;
          flex-direction: column;
          ${mq.untilMedium} {
            padding: 16px 16px 36px;
          }
          ${mq.large} {
            padding: 16px 40px 32px;
          }
        `}
        data-testid="trial-modal"
      >
        <div
          css={css`
            font-weight: ${font.weight.normal};
            line-height: 175%;
            letter-spacing: 0.02em;
            color: ${colors.text};
            ${mq.untilMedium} {
              font-size: 14px;
            }
            ${mq.large} {
              font-size: 16px;
            }
          `}
        >
          有料契約限定のコンテンツです。無料トライアルに申し込むと、すべての機能/コンテンツをご覧になれます（一部対象外の機能あり）。
        </div>
        <Link href={trialRequestUrl} passHref>
          <a target="_blank" className="trial-link">
            <Button
              css={css`
                ${mq.untilMedium} {
                  margin-top: 16px;
                  width: 310px;
                }
                ${mq.large} {
                  margin-top: 26px;
                  width: 320px;
                }
              `}
            >
              無料トライアルに申し込む
            </Button>
          </a>
        </Link>
        <A
          decoration="none"
          href={loginPath}
          css={css`
            margin-top: 20px;
            font-size: 14px;
          `}
        >
          契約済みの方はログインしてください
        </A>
      </div>
    </Modal>
  )
}
